import saveAs from 'file-saver';

import { omdApi } from '../../api';
import { OperatingSchedule, OperatingScheduleRequest, OperatingScheduleRequestData } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getOperatingScheduleList: builder.query<OperatingSchedule[], OperatingScheduleRequest>({
      query: (params) => ({
        url: '/v1/OperatingSchedule',
        params,
      }),
    }),

    changeOperatingScheduleList: builder.mutation<void, OperatingScheduleRequestData>({
      query: (data) => ({
        url: '/v1/OperatingSchedule/',
        method: 'POST',
        body: data,
      }),
    }),

    getOperatingScheduleReport: builder.query<void, OperatingScheduleRequest>({
      query: (params) => ({
        url: '/v1/OperatingSchedule/excelReport',
        method: 'GET',
        params,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'report.xlsx');
        },
        cache: 'no-cache',
      }),
    }),
  }),
});

export const {
  useGetOperatingScheduleListQuery,
  useChangeOperatingScheduleListMutation,
  useLazyGetOperatingScheduleReportQuery,
} = request;
